import React from 'react';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import { Toolbar, BackButton } from 'react-onsenui';
import './Toolbar.css';
import PropTypes from 'prop-types';
import ToolbarRightMenuButton from '../ToolbarRightMenuButton';
import ToolbarRightMenuButtonSpectator from './ToolbarRightMenuButtonSpectator';

const Header = props => {
    return (
        <Toolbar modifier='material ls_toolbar ls_toolbar_large'>
            <div className='center ls_toolbar_live_container' style={{backgroundImage: `url(${require('../../../images/bglivescore.jpg')})`, minHeight: '277px', margin: 0, backgroundSize: 'cover'}}>
                    <Toolbar modifier='ls_toolbar ls_toolbar_large noshadow'>
                        <div className="left" style={{paddingTop: '5px', paddingLeft: '10px'}}>
                            <BackButton 
                                onClick={() => {
                                    localStorage.removeItem('/api/lives/demo');
                                    if(props.back !== '' && props.back !== undefined && props.back !== null) {
                                        props.history.push(props.back);
                                    }
                                    else{
                                        props.history.goBack();
                                    }
                                }} 
                                modifier='ls_back'
                            >
                            </BackButton>
                        </div>
                        <div className="center" style={{textTransform: 'uppercase', color: '#fff', textAlign: 'center', fontSize: '15px', fontFamily: 'fff-equipe', height: 95}}>{props.title}</div>
                        <div style={{paddingRight: '10px'}} className="right ls_contextual">
                            {
                                 _.isArray(props.settings) && props.settings.length > 0 ? <RightMenuButton {...props} /> : <div></div>
                            }
                        </div>
                    </Toolbar>
                    <Toolbar modifier='transparent ls_toolbar_large cover-content noshadow'>
                        <div className='center'>
                            {props.children}
                        </div>
                    </Toolbar>
            </div>
        </Toolbar>
    );
}

const RightMenuButton = props => props.isSpectator ? <ToolbarRightMenuButtonSpectator settings={props.settings} idLive={props.idLive} /> : <ToolbarRightMenuButton settings={props.settings} />

Header.propTypes = {
    close: PropTypes.bool,
    history: PropTypes.object.isRequired,
    back: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    settings: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        to: PropTypes.string,
        name: PropTypes.string
    })),
    isSpectator: PropTypes.bool,
    idLive: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default withRouter(Header);